import bService from '@/api/base-api'
import { CONTRACT_MANAGER_URL } from '@/configs/service-url'

const list = async (hotelId) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/supplement`
  const result = await bService.get(url)

  return result
}

const create = async (hotelId, data) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/supplement`
  const result = await bService.post(url, data)

  return result
}

const update = async (hotelId, supplementId, data) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/supplement/${supplementId}`
  const result = await bService.put(url, data)

  return result
}

const updateIsDefault = async (hotelId, supplementId, data) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/supplement/${supplementId}/is-default`
  const result = await bService.put(url, data)

  return result
}

const remove = async (hotelId, supplementId) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/supplement/${supplementId}`
  const result = await bService.remove(url)

  return result
}

const removePeriod = async (hotelId, supplementId, data) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/supplement/${supplementId}/delete-period`
  await bService.remove(url, data)
}

export default {
  list,
  create,
  update,
  updateIsDefault,
  remove,
  removePeriod
}
